/**
 * @license
 * @copyright Copyright Motili Inc., 2026 All Rights Reserved
 */

import Config from 'Config';
import { ReactNode } from 'react';
import { IconButton } from '@mui/material';
import styles from './ActiveFilterPill.module.scss';

interface ActiveFilterPillProps {
    children: ReactNode;
    dataTestId?: string;
    clearable?: boolean;
    onFilterClose?: () => void;
}

const ActiveFilterPill = ({
    children,
    dataTestId,
    clearable = true,
    onFilterClose,
}: ActiveFilterPillProps) => (
    <div className={styles.activeFilterPill} data-test-id={dataTestId}>
        {children}
        {clearable && (
            <IconButton
                type='button'
                sx={{ padding: 0 }} // Override default padding
                onClick={onFilterClose}
                data-test-id='close-button'
                aria-label='Close'
            >
                <i
                    className='fa fa-times-circle'
                    style={{ fontSize: '19px', color: Config.color.mediumGray }}
                    aria-hidden='true'
                />
            </IconButton>
        )}
    </div>
);

export default ActiveFilterPill;
